import { render, staticRenderFns } from "./LifeRecordFunctionsDashboard.vue?vue&type=template&id=834979d8"
import script from "./LifeRecordFunctionsDashboard.vue?vue&type=script&lang=js"
export * from "./LifeRecordFunctionsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports